export enum AppSubdomain {
    accounts = 'account-settings',
    analytics = 'analytics',
    devCenter = 'devcenter',
    earn = 'earn',
    profiles = 'profiles',
    tcAcademy = 'academy',
    onboarding = 'onboarding',
    work = 'work',
    wallet = 'wallet',
    walletAdmin = 'wallet-admin',
    copilots = 'copilots',
    campus = 'campus',
    admin = 'system-admin',
    review = 'review',
    calendar = 'calendar',
    engagements = 'engagements',
    customer = 'customer',
    reports = 'reports',
    procurement = 'procurement',
    status = 'status',
    support = 'support',
    opportunities = 'opportunities'
}

export enum ToolTitle {
    accounts = 'Account Settings',
    analytics = 'Analytics',
    devCenter = 'Dev Center',
    earn = 'Opportunity Feed',
    profiles = 'Profiles',
    tcAcademy = 'Topcoder Academy',
    selfService = 'Self Service Challenges',
    onboarding = ' ',
    work = 'Work',
    wallet = 'Wallet',
    walletAdmin = 'Wallet Admin',
    copilots = 'Copilots',
    campus = 'Campus',
    admin = 'Admin',
    review = 'Review',
    calendar = 'Calendar',
    engagements = 'Engagements',
    customer = 'Customer',
    reports = 'Reports',
    procurement = 'Procurement',
    status = 'Status',
    support = 'Support',
    opportunities = 'Opportunities',
    thrive = 'Thrive'
}

export const PageSubheaderPortalId: string = 'page-subheader-portal-el'
